import React from 'react';
import Typewriter from 'typewriter-effect';
import styled from 'styled-components';

const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 22rem;
  z-index: 1;
  margin-top: -125px;
  text-align: center;

  strong {
    font-size: 1.25em;
  }
  div {
    color: ${(props) => props.theme.textColor};

    text-shadow: 7px 2px 3px rgba(0, 0, 0, 0.3);
    font-weight: 150;
    letter-spacing: 13px;

    .main {
      font-size: 40px;
    }

    .sub {
      font-size: 27px;
      font-weight: 170;
      letter-spacing: 2px;
    }
    .myname {
      ${'' /* color: #e88c13; */}
      color: #f7faeb;
      font-size: 1.6em;
      font-weight: 200;
    }
  }
`;

const TitleMessage = () => (
  <MyTitleMessage>
    <div className='titleMessage'>
      <div className='heading'>
        <div className='main text-center mb-3'>
          Hey there,
          <br /> I am
          <br />
          <span>
            <strong className='myname'>Ayush Tiwari</strong>
          </span>
        </div>
        <div className='sub'>
          <Typewriter
            options={{
              strings: ['Web Developer', 'Freelancer', 'Learner'],
              autoStart: true,
              loop: true,
              delay: 45,
            }}
          />
        </div>
      </div>
    </div>
  </MyTitleMessage>
);

export default TitleMessage;
